import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
const COOKIE_CONSENT_KEY = 'noord-cookie-consent';
type ConsentStatus = 'accepted' | 'declined' | null;
export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);
  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY) as ConsentStatus;
    if (!stored) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => {
        setVisible(true);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => setAnimateIn(true));
        });
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };
  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };
  if (!visible) return null;
  return <div className={`fixed bottom-0 left-0 right-0 z-[60] transition-all duration-300 ease-out ${animateIn ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`} data-id="element-360">
      <div className="bg-navy-900 border-t border-navy-700 shadow-2xl" data-id="element-361">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5" data-id="element-362">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-363">
            {/* Norden + Text */}
            <div className="flex items-start gap-4 flex-1 min-w-0" data-id="element-364">
              <img src="https://cdn.magicpatterns.com/uploads/npubyk3qrHvFQon2qy3aCN/Norden_die_cookie_eet_nom.png" alt="Norden eet een cookie" className="w-14 h-14 sm:w-16 sm:h-16 object-contain flex-shrink-0 -mt-1 select-none pointer-events-none" draggable={false} data-id="element-365" />
              <div data-id="element-366">
                <p className="text-white text-sm font-medium leading-relaxed" data-id="element-367">
                  Norden lust wel een cookie, jij ook? Wij gebruiken cookies om
                  je ervaring te verbeteren en onze website te analyseren.
                </p>
                <p className="text-navy-300 text-xs mt-1 leading-relaxed" data-id="element-368">
                  Door op "Accepteren" te klikken ga je akkoord met het gebruik
                  van analytische cookies. Met "Alleen noodzakelijk" worden
                  alleen functionele cookies geplaatst.{' '}
                  <a href="#/website-beveiliging" className="text-accent-light hover:text-white underline transition-colors" data-id="element-369">
                    Meer informatie
                  </a>
                </p>
                <p className="text-navy-400 text-[11px] mt-2 leading-relaxed" data-id="element-370">
                  Deze website is gemaakt met{' '}
                  <a href="https://www.magicpatterns.com" target="_blank" rel="noopener noreferrer" className="text-accent-light hover:text-white underline transition-colors font-medium" data-id="element-371">
                    MagicPatterns
                  </a>
                  , net als noorddigital.nl.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto" data-id="element-372">
              <button onClick={handleDecline} className="flex-1 sm:flex-initial px-5 py-2.5 text-sm font-semibold text-navy-200 hover:text-white border border-navy-600 hover:border-navy-400 rounded-lg transition-all duration-200" data-id="element-373">
                Alleen noodzakelijk
              </button>
              <button onClick={handleAccept} className="flex-1 sm:flex-initial px-5 py-2.5 text-sm font-bold text-white bg-accent hover:bg-accent-hover rounded-lg transition-all duration-200 shadow-md" data-id="element-374">
                Accepteren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}